import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class LastSeenService {
  constructor(router: Router, http: HttpClient, @Inject('IEnvironmentService') envService: EnvironmentService) {
    const endpoint = envService.getVar('services.api');
    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      switch (event.urlAfterRedirects) {
        case '/app/dashboard':
        case '/app/offers':
        case '/app/conversions':
          http.get(endpoint + '/last-seen').subscribe();
          break;
      }
    });
  }
}
